module.exports = __webpack_public_path__ + "static/img/eq5.762557d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/eq5.png
// module id = PIYD
// module chunks = 0